import React from "react";
import "./style.css";
import { NewsListObjects } from "../../models/testData/NewsList";

const NewsPage: React.FC = () => {
  return (
    <div className={"news-wrapper"}>
      {NewsListObjects.map((item, index) => (
        <div className={"news-container"} key={index} style={{ backgroundImage: `url(${item.picture})` }}>
          <div className={"news-section"}>
            <h3>{item.title}</h3>
            <div className={"news-body"} dangerouslySetInnerHTML={{ __html: item.body }}></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NewsPage;
